// extracted by mini-css-extract-plugin
export var layoutContainer = "_bb-0";
export var layoutContainerNoRounding = "_bb-6";
export var layoutContainerOpen = "_bb-5";
export var layoutContainerResizing = "_bb-1";
export var mainContent = "_bb-2";
export var resizeDivider = "_bb-3";
export var slidePanel = "_bb-4";